import { Provider } from '@angular/core';
import { ChatPaymentsService } from 'src/shared/services/chat-payments/chat-payments.service';
import { ChatAvailabilityStore } from 'src/shared/stores/chat/chat-availability.store';
import { ChatConnectionStore } from 'src/shared/stores/chat/chat-connection.store';
import { ChatDataStore } from 'src/shared/stores/chat/chat-data.store';
import { ChatFacade } from 'src/shared/stores/chat/chat-facade.store';
import { ChatUIStore } from 'src/shared/stores/chat/chat-ui.store';
import {
  CHAT_AVAILABILITY_STORE,
  CHAT_CONNECTION_STORE,
  CHAT_DATA_STORE,
  CHAT_UI_STORE,
} from 'src/shared/stores/chat/stream-chat-tokens/stream-chat.tokens';

export function provideTrialsChat(): Provider[] {
  return [
    ChatUIStore,
    ChatDataStore,
    ChatConnectionStore,
    ChatAvailabilityStore,
    ChatFacade,
    ChatPaymentsService,
    { provide: CHAT_UI_STORE, useExisting: ChatUIStore },
    { provide: CHAT_DATA_STORE, useExisting: ChatDataStore },
    { provide: CHAT_CONNECTION_STORE, useExisting: ChatConnectionStore },
    { provide: CHAT_AVAILABILITY_STORE, useExisting: ChatAvailabilityStore },
  ];
}
